import { Link } from 'react-router-dom';
import { TRUST_ITEMS } from '@/content/features';

/**
 * TrustStrip Component
 * Horizontal strip displaying key trust/compliance indicators
 * Includes link to privacy/terms
 */
export default function TrustStrip() {
  return (
    <section className="py-12 bg-primary-500 dark:bg-primary-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Trust Items Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-6">
          {TRUST_ITEMS.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-3 text-white"
            >
              {/* Icon */}
              <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                <span className="text-xl" role="img" aria-hidden="true">
                  {item.icon}
                </span>
              </div>

              {/* Text */}
              <span className="font-medium text-sm sm:text-base">
                {item.text}
              </span>
            </div>
          ))}
        </div>

        {/* Link to Privacy/Terms */}
        <div className="text-center">
          <Link
            to="/privacy"
            className="inline-flex items-center gap-2 text-white/90 hover:text-white text-sm font-medium transition-colors duration-200 underline underline-offset-4"
          >
            Read our Privacy Notice & Terms
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}

